import { ref, watch } from "vue";

/**
 * One-shot signal: resolves once the 3D viewer's toolbar has loaded and its anchors exist in the
 * DOM. Same shape as useProjectDashboardReadySignal.ts / useLibraryReadySignal.ts.
 */
const isReady = ref(false);

export function markViewerReady(): void {
  isReady.value = true;
}

export function resetViewerReady(): void {
  isReady.value = false;
}

export function waitForViewerReady(): Promise<void> {
  if (isReady.value) return Promise.resolve();

  return new Promise<void>((resolve) => {
    const stop = watch(isReady, (ready) => {
      if (ready) {
        stop();
        resolve();
      }
    });
  });
}
